"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemsKit = exports.MenuItemsKitEnum = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const material_1 = require("@mui/material");
const envConfig_1 = require("../../../utils/helpers/config/envConfig");
var MenuItemsKitEnum;
(function (MenuItemsKitEnum) {
    MenuItemsKitEnum["PROMPT_DELIVERY"] = "Pronta-entrega";
    MenuItemsKitEnum["PROMOTION"] = "Promo\u00E7\u00F5es";
})(MenuItemsKitEnum = exports.MenuItemsKitEnum || (exports.MenuItemsKitEnum = {}));
const MenuItemsKit = ({ facetsConfig, menuItemsKitType, Icon }) => {
    const DOMAIN_URL = `${envConfig_1.envConfig.multibrandUrl}/${facetsConfig.catalogSlug}`;
    const promotionUrl = `${DOMAIN_URL}/categoria?category=promocao`;
    const promptDeliveryUrl = `${DOMAIN_URL}/pronta-entrega`;
    const handleButtonClick = () => {
        if (menuItemsKitType === MenuItemsKitEnum.PROMPT_DELIVERY) {
            window.location.assign(promptDeliveryUrl);
        }
        if (menuItemsKitType === MenuItemsKitEnum.PROMOTION) {
            window.location.assign(promotionUrl);
        }
    };
    return ((0, jsx_runtime_1.jsx)(material_1.ListItem, Object.assign({ disablePadding: true }, { children: (0, jsx_runtime_1.jsxs)(flora_react_1.Button, Object.assign({ variant: "unstyled", css: { height: 'inherit' }, "autotagging-flora": "on", "data-flora-text": menuItemsKitType, "data-flora": "button", "data-autotagging-flora-section": "menu", as: material_1.ListItemButton, sx: { height: 56 }, onClick: handleButtonClick }, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemIcon, Object.assign({ sx: { minWidth: 0, marginRight: '10px' } }, { children: Icon })), (0, jsx_runtime_1.jsx)(material_1.ListItemText, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "bodyLargeShortRegular" }, { children: menuItemsKitType })) })] })) })));
};
exports.MenuItemsKit = MenuItemsKit;
exports.default = exports.MenuItemsKit;
